export default __webpack_public_path__ + "static/media/maqui.08425806.gif";